import { createRoutine } from "redux-saga-routines";

export const userNotesRoutine = createRoutine("app/userNotes/SAVE_NOTE");

export default (state = {}) => state;
